export enum GalleryPrivacy {
  PUBLIC = "public",
  UNLISTED = "unlisted",
  PRIVATE = "private"
}

export interface GalleryJson {
  title: string
  privacyLevel: GalleryPrivacy
  hashtag: string
  _links: any | null
  socialSharing: any
  moderated: boolean
  finePrint: any
  totalUploads: number
}

export class Gallery {
  title: string
  privacy: GalleryPrivacy
  hashtag: string
  latestUploadsUrl?: string
  url?: string
  sharing: any
  moderated: boolean
  finePrint: any
  totalUploads: number

  constructor(galleryJson: GalleryJson) {
    this.title = galleryJson.title;
    this.privacy = galleryJson.privacyLevel;
    this.hashtag = galleryJson.hashtag;
    if (galleryJson._links != null) {
      if (galleryJson._links["web:self"] != null) {
        this.url = galleryJson._links["web:self"].href;
      }
      if (galleryJson._links.latestUploads != null) {
        this.latestUploadsUrl = galleryJson._links.latestUploads.href;
      }
    }
    this.sharing = galleryJson.socialSharing;
    this.moderated = galleryJson.moderated;
    this.finePrint = galleryJson.finePrint;
    this.totalUploads = galleryJson.totalUploads;
  }
}
